const queueActionTypes = {
  FETCH_QUEUE_REQUEST: 'FETCH_QUEUE_REQUEST',
  FETCH_QUEUE_SUCCESS: 'FETCH_QUEUE_SUCCESS',
  FETCH_QUEUE_FAILURE: 'FETCH_QUEUE_FAILURE',
};

export default queueActionTypes;
